import { render, staticRenderFns } from "./DesignGetStartedPrinciples.vue?vue&type=template&id=187253d8"
import script from "./DesignGetStartedPrinciples.vue?vue&type=script&lang=js"
export * from "./DesignGetStartedPrinciples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports